import { Component, OnInit } from '@angular/core';
import {getSemesterApi, getSemesterByIdApi} from '../api/students';

@Component({
  selector: 'app-sis-code',
  templateUrl: './sis-code.component.html',
  styleUrls: ['./sis-code.component.css']
})
export class SisCodeComponent implements OnInit {

  constructor() { }

  sisCode=[]
  semster=[]
  removedSisCode=[]
  ngOnInit() {

    this.getSemster()
  }


  async getSemster() {
    const result = await getSemesterApi();
    if (result) {
      const data = result.data.data;
      this.semster=data
    }
  }
  async getSemsterID(id) {
    console.log('sss')

    const result = await getSemesterByIdApi(id);
    if (result) {
      const data = result.data.data;
      this.sisCode=data.sis_code
    }
  }



}
